// Emblem exakt aus dem originalen MAZARO Logo nachgezeichnet (Vektor-Trace)
const EMBLEM_PATH =
  "M0.0 0.0 L11.5 18.9 L77.4 53.9 L75.7 55.6 L19.3 30.9 L31.3 49.4 L79.9 72.0 L77.8 73.3 L40.8 60.5 L51.9 76.2 L81.9 87.7 L112.8 117.3 L114.4 115.7 L106.2 92.6 L100.0 87.3 L102.9 84.4 L101.7 72.9 L119.0 91.4 L138.3 73.7 L136.3 84.4 L139.1 87.7 L133.0 93.4 L125.6 115.3 L127.2 117.3 L157.3 87.7 L189.0 75.3 L199.2 60.5 L159.3 72.9 L160.1 71.2 L209.1 49.0 L220.7 30.9 L162.6 56.0 L161.8 54.3 L228.5 18.5 L239.6 1.6 L237.9 0.0 L139.1 45.3 L119.4 67.9 L99.6 44.9 Z";
const EMBLEM_VH = 117.7;

export function WingedM({ size = 42 }) {
  return (
    <svg width={size} height={size * (EMBLEM_VH / 240)} viewBox={`0 0 240 ${EMBLEM_VH}`} aria-hidden="true">
      <path d={EMBLEM_PATH} fill="#C9A227" fillRule="evenodd" />
    </svg>
  );
}

export function Tricolor({ className = "" }) {
  return (
    <span className={`inline-flex h-1 ${className}`} aria-hidden="true">
      <span className="flex-1 bg-[#009246]" />
      <span className="flex-1 bg-[#F4F4F5]" />
      <span className="flex-1 bg-[#CE2B37]" />
    </span>
  );
}

export default function Logo({ compact = false }) {
  return (
    <span className="flex items-center gap-3">
      <WingedM size={46} />
      {!compact && (
        <span className="flex flex-col leading-none">
          <span className="font-display font-black uppercase tracking-[0.22em] text-lg">Mazaro</span>
          <span className="font-mono text-[8px] tracking-[0.42em] uppercase text-gold mt-1">Born to Fight</span>
        </span>
      )}
    </span>
  );
}
